/*
  ChatMessageDto
  
  Payload of plaintext message. Conforms to a JSON Web Message https://datatracker.ietf.org/doc/html/draft-looker-jwm-01
*/
export var MessageType;
(function (MessageType) {
    /* Normal text message */
    MessageType["MESSAGE"] = "message";
    /* Request for others to sign a message */
    MessageType["SIGNATURE_REQUEST"] = "signature_request";
    /* Get Stream Specific Message */
    MessageType["GET_STREAM"] = "get_stream";
    /* Unknown message type */
    MessageType["UNKNOWN"] = "unknown";
})(MessageType || (MessageType = {}));
